import { render, staticRenderFns } from "./DeliveryBlockBuyer.vue?vue&type=template&id=05bab724&"
import script from "./DeliveryBlockBuyer.vue?vue&type=script&lang=js&"
export * from "./DeliveryBlockBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports